import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const history = {
      location,
      push: (to, state) => navigate(to, { state }),
      replace: (to, state) => navigate(to, { replace: true, state }),
      go: navigate,
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
    };
    
    const match = {
      params,
      url: location.pathname,  // Esto resolverá el error "match.url no existe"
      path: location.pathname
    };

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        match={match}
        history={history}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}